<template>
  <div class="dashboard-container">
        <!-- 仪表盘内容 -->
        <div class="dashboard-tab">
          <AdminProgressbar :current-step="0" :tenantId="tenantId"/>
          <h3 class="tab-title">数据概览</h3>
           <span class = "alert-text" v-if="tenantderegistration.apply_datetime && tenantInfo.status.trim()==='DELETED'">
        <svg t="1793292720960" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5630" width="16" height="16"><path d="M64 256A192 192 0 0 1 256 64h512A192 192 0 0 1 960 256v512a192 192 0 0 1-192 192H256A192 192 0 0 1 64 768V256z" fill="#FF585A" p-id="5631"></path><path d="M742.144 605.696l-181.76-292.437333c-12.928-23.168-28.330667-34.304-48.085333-34.304-19.712 0-35.968 11.136-48 33.450666L282.453333 605.696c-12.885333 22.272-13.738667 42.026667-3.456 59.178667 10.24 17.152 28.288 25.770667 53.162667 25.770666h360.234667c24.874667 0 42.837333-8.533333 53.162666-25.770666 9.386667-17.152 8.533333-36.864-3.413333-59.178667z m-229.845333 33.450667a25.813333 25.813333 0 0 1-25.728-25.770667c0-14.549333 12.032-25.728 25.728-25.728 14.592 0 25.770667 12.032 25.770666 25.770667 0.853333 13.696-11.178667 25.728-25.770666 25.728z m21.461333-102.101334c0 33.493333-42.88 33.493333-42.88 0l-8.533333-108.928c0-16.256 13.696-29.141333 29.952-29.141333 16.298667 0 30.037333 12.885333 30.037333 29.141333l-8.576 108.928z" fill="#FFFFFF" p-id="5632"></path></svg>
        {{ '您所属的租户已于'+tenantderegistration.apply_datetime+'申请注销，目前处于受限模式。' }}</span>
          <div class="dashboard-stats">
            <div class="stat-card">
              <div class="stat-value">{{ employeeCount }}</div>
              <div class="stat-label">员工总数</div>
            </div>
            <div class="stat-card">
              <div class="stat-value">{{ }}{{ workspace_count }}</div>
              <div class="stat-label">知识库数量</div>
            </div>
            <div class="stat-card">
          <div class="stat-value">{{ document_count }}</div>
          <div class="stat-label">文档数量</div>
        </div>
        <div class="stat-card">
          <div class="stat-value">{{ aics_center_count }}</div>
          <div class="stat-label">AI客服中心数量</div>
        </div>
        <div class="stat-card">
          <div class="stat-value">{{ aics_seat_count }}</div>
          <div class="stat-label">AI客服席位数量</div>
        </div>
        <div class="stat-card">
          <div class="stat-value">{{ solved_rate }}%</div>
          <div class="stat-label">问题解决率(今年)</div>
        </div>
        <div class="stat-card">
          <div class="stat-value"  style="color: red;">{{ missed_hits_rate }}%</div>
          <div class="stat-label">未命中率<br>(今年)</div>
        </div>
          </div>
        </div>
        <div class="dashboard-charts">
            <div class="chart-container">
        <h4>近7日咨询量趋势</h4>
        <div class="chart-placeholder">
          <AdminConversationTrendChart :tenantId="tenantId" />
        </div>
            </div>
            <div class="chart-container">
              <h4>问题分类统计</h4>
                   <AdminIntentPieChart :tenantId="tenantId"/>
            </div>
          </div>
        </div>
   </template>

   <script>


import { countDashboard } from '@/api/tenant/dashboard';
import { get_my_tenant_deregistration_info } from '@/api/tenant/tenant'
import AdminProgressbar from '@/components/admin/progressbar.vue'; //进度条组件
import AdminConversationTrendChart from '../chart/AdminConversationTrendChart.vue'
import AdminIntentPieChart from '../chart/AdminIntentPieChart.vue';

//import { mapState } from 'vuex';
   export default {
       name: "AdminDashboard",
    components: {
          AdminProgressbar,
          AdminIntentPieChart,
          AdminConversationTrendChart  
    },
   /*    props: {
        tenantId:{
          type: Number,
          value:0
        }
       },*/
       data() {
         return {
            employeeCount: 0,
            workspace_count: -1,
            document_count: -1,
            aics_center_count: -1,
            aics_seat_count: -1,
            solved_rate: -1,
            missed_hits_rate: -1,
            tenantderegistration: null

         };
       },
   computed: {
     //...mapState('auth', ['tenantInfo', 'userInfo','loginType']),

     tenantInfo() {
      return this.$store.getters['auth/currentTenant'];
     },
     tenantId() {
      return this.tenantInfo?.tenantId || null;
     },
     userName() {
      return this.userInfo?.username || null;
     },
     versionName() {
      return this.tenantInfo?.versionName || null;
     },
     maxFileCount() {
      return this.tenantInfo?.maxFileCount || 0;
     },
     maxStorageSpace() {
      return this.tenantInfo?.maxStorageSpace || 0;
     },
     kbworkspaceFolder() {
      return this.tenantInfo?.kbworkspaceFolder;

     }
  },       
  mounted() {
        console.log(" dashboard mounted:",this.tenantId,this.username)
        
        // 知识库数量
        countDashboard(this.tenantId,this.username).then(res => {
          console.log("countDashboard res:", res.data)
          if(res.data.code === 200){
            this.workspace_count = res.data.data.knowledge_count;
            this.document_count = res.data.data.document_count;
            this.aics_center_count = res.data.data.aics_center_count;
            this.aics_seat_count = res.data.data.aics_seat_count;
            this.solved_rate = res.data.data.ai_resoved_rate;
            this.fail_rate = res.data.data.missed_hits_rate;
          }
        }).catch(err => {
          console.log("countKnowledgeBases err:", err)
        });

        // 获取租户注销信息
        get_my_tenant_deregistration_info(this.tenantInfo?.tenantId)
          .then(response => {
            console.log("dashboard this.tenantderegistration response", response);
            
            if (response && response.code === 200) {
              console.log("code:", response.code);
              console.log("data:", response.data);
              console.log("message:", response.message);
              
              this.tenantderegistration = response.data;
              console.log("this.tenantderegistration", this.tenantderegistration);
            }   
          })
          .catch(error => {
            console.error("获取租户注销信息失败:", error);
          });
   }

  }
  </script>
     <style scoped>

/* 仪表盘样式 */
.dashboard-tab {
  padding: 0;
}

.tab-title {
  color: #333;
  margin-bottom: 5px;
  font-size: 1.5rem;
  font-weight: 500;
}

.dashboard-stats {
  display: flex;
  gap: 20px;
  margin-bottom: 30px;
}

.stat-card {
  flex: 1;
  background: white;
  border-radius: 8px;
  padding: 25px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
  text-align: center;
  transition: all 0.3s;
  border-bottom: 3px solid #057FDB;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 5px 15px rgba(0,0,0,0.1);
  }
}

.stat-value {
  font-size: 2.2rem;
  font-weight: bold;
  color: #057FDB;
  margin-bottom: 10px;
}

.stat-label {
  color: #666;
  font-size: 0.95rem;
}

.dashboard-charts {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-top: 30px;
}

.chart-container {
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);

  h4 {
    color: #333;
    margin-bottom: 15px;
    font-size: 1.1rem;
  }
}

.chart-placeholder {
  height: 250px;
  background: #f9f9f9;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
}

.loading-state {
  padding: 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
}
.alert-text{
  display: block;
  color: coral;
  font-size: small;
  margin: 0 0 20px 20px;
  height: 20px;
  line-height: 20px;
}
    </style>